import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";
import { api, errMsg } from "../lib/api";

const card = "bg-white border border-slate-200/80 rounded-2xl shadow-sm p-5";
const input = "w-full border rounded-xl px-3 py-2 text-sm bg-white";
const label = "text-xs text-slate-600 mb-1 block";

const SECTIONS = [
  {
    title: "پیامک ورود (ملی پیامک)",
    fields: [
      { key: "sms_username", label: "نام کاربری پنل پیامک" },
      { key: "sms_password", label: "رمز پنل پیامک", type: "password" },
      { key: "sms_from", label: "شماره فرستنده", dir: "ltr" },
      { key: "otp_ttl_seconds", label: "اعتبار کد (ثانیه)", type: "number" },
      { key: "otp_resend_seconds", label: "فاصله ارسال مجدد (ثانیه)", type: "number" },
      { key: "otp_max_attempts", label: "حداکثر تلاش اشتباه", type: "number" },
    ],
  },
  {
    title: "اطلاعات فروشنده (پیش‌فاکتور)",
    fields: [
      { key: "invoice_seller_name", label: "نام فروشنده" },
      { key: "invoice_seller_national_id", label: "شناسه ملی", dir: "ltr" },
      { key: "invoice_seller_economic_code", label: "کد اقتصادی", dir: "ltr" },
      { key: "invoice_seller_registration_no", label: "شماره ثبت", dir: "ltr" },
      { key: "invoice_seller_postal_code", label: "کد پستی", dir: "ltr" },
      { key: "invoice_seller_phone", label: "تلفن", dir: "ltr" },
      { key: "invoice_seller_address", label: "نشانی" },
    ],
  },
  {
    title: "پیش‌فرض‌های پیش‌فاکتور",
    fields: [
      { key: "invoice_tax_percent", label: "درصد مالیات و عوارض", type: "number" },
      { key: "invoice_due_days", label: "مهلت پرداخت (روز)", type: "number" },
    ],
  },
];

export default function PortalSettings() {
  const [values, setValues] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/settings")
      .then(({ data }) => setValues(data.settings))
      .catch((e) => toast.error(errMsg(e)));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const keys = SECTIONS.flatMap((s) => s.fields.map((f) => f.key));
      const payload = Object.fromEntries(keys.map((k) => [k, values[k] ?? ""]));
      await api.put("/admin/settings", { settings: payload });
      toast.success("تنظیمات ذخیره شد");
    } catch (err) { toast.error(errMsg(err)); }
    finally { setSaving(false); }
  };

  if (!values) return <div className="grid place-items-center py-16 text-slate-400"><Loader2 className="animate-spin" /></div>;

  return (
    <form onSubmit={save} className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-bold">پیامک و پیش‌فاکتور</h1>
        <button disabled={saving} className="bg-teal-600 hover:bg-teal-700 text-white text-sm px-5 py-2 rounded-xl flex items-center gap-2">
          {saving ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} ذخیره
        </button>
      </div>
      {SECTIONS.map((sec) => (
        <div key={sec.title} className={card}>
          <div className="font-medium mb-4">{sec.title}</div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {sec.fields.map((f) => (
              <div key={f.key} className={f.key === "invoice_seller_address" ? "md:col-span-2" : ""}>
                <label className={label}>{f.label}</label>
                <input
                  type={f.type || "text"}
                  dir={f.dir}
                  className={input}
                  value={values[f.key] ?? ""}
                  onChange={(e) => setValues({ ...values, [f.key]: e.target.value })}
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </form>
  );
}
